<div class="modal-dialog modal-dialog-centered modal show">
  <div class="modal-body">
    <div class="modal-content modal-bg modal-bg-wallet">
      <div class="modal-header">
        <h4 class="modal-title">{{ 'Claim' | translate}} {{ 'Reward' | translate }} {{ data.reward.name ? ' - ' + data.reward.name : '' }}</h4>
        <button type="button" class="close" (click)="onCloseDialog()">&times;</button>
      </div>
      <hr>
      <div class="claim-modal">
        <form [formGroup]="form" id="claim-reward-modal-form" name="claim-reward-modal-form">
          <ng-container *ngIf="data.reward.promo_type === 3 && !promoType('BTG_CHALLENGE_PHASE_1', data.reward); else ppChallege">
            <div class="d-flex justify-content-evenly claim-field mb-2" [ngClass]="{ 'is-invalid' : form.controls['game_provider_id'].errors }">
              <div class="p-2 flex flex-fill claim-field-label col-5"><p class="m-0 pt-1 pl-2">{{ 'Transfer To' | translate }}</p></div>
              <div class="p-2 flex flex-fill claim-field-content col-7">
                <select formControlName="game_provider_id" class="col grey" [ngClass]="{'form-invalid dropdown-invalid' : checkValidity && form.controls.game_provider_id.errors}" (change)="onProviderChange($event)">
                  <option [value]="null" disabled>{{ 'Please Select' | translate }}</option>
                  <ng-container *ngFor="let item of providersDropdown">
                    <option [value]="item.id" [disabled]="item.status === 2">{{ item.name}}</option>
                  </ng-container>
                </select>
              </div>
            </div>

            <div class="d-flex justify-content-evenly claim-field mb-2">
              <div class="p-2 flex flex-fill claim-field-label col-5"><p class="m-0 pt-1 pl-2">{{ 'Bonus Amount' | translate }}</p></div>
              <div class="p-2 flex flex-fill claim-field-content col-7 p-0">
                <input class="form-control form-control-sm form-input-style m-0" type="text" placeholder="{{ 'Enter Amount' | translate }}" [value]="data.reward.amount" digitOnly decimal="true" decimalSeparator="." pattern="^\d+(\.\d{1,2})?$" disabled="">
              </div>
            </div>

            <div class="mb-4 mt-2">
              <p *ngIf="form.controls.game_provider_id.errors" class="exchange-font m-b-0 mt-1">
                {{ 'Please select the game wallet to transfer the reward amount.' | translate }}
              </p>
              <ng-container *ngIf="!form.controls.game_provider_id.errors">
                <p class="exchange-font m-b-0 mt-1">
                  {{ 'You are entitled to promotion(s) for this game provider' | translate }}
                </p>
                <p class="exchange-font">
                  {{ onDisplayTargetName(form.value.game_provider_id) | translate }}: <br>
                  {{ onDisplayFormula(+form.value.amount, data.reward, form.value.game_provider_id) }}
                </p>
              </ng-container>
            </div>

            <div class="mt-2" *ngIf="showIDRRate | async">
              <p class="text-blue">
                  {{ 'Exchange Rate' | translate }} <br> IDR 1:0.2 {{ providerName | uppercase }} {{ 'Credits' | translate }}
              </p>
            </div>

          </ng-container>

          <ng-template #ppChallege>
            <ng-container *ngIf="promoType('PP_CHALLENGE_PHASE_1', data.reward); else btgChallenge">
              <div class="d-flex justify-content-evenly claim-field mb-2">
                <div class="p-2 flex flex-fill claim-field-label col-5"><p class="m-0 pt-1 pl-2">{{ 'Game Provider' | translate }}</p></div>
                <div class="p-2 flex flex-fill claim-field-content col-7 p-0">
                  <input class="form-control form-control-sm form-input-style m-0" type="text" [value]="data.reward.game_provider_name" disabled>
                </div>
              </div>

              <div class="d-flex justify-content-evenly claim-field mb-2">
                <div class="p-2 flex flex-fill claim-field-label col-5"><p class="m-0 pt-1 pl-2">{{ 'Game Name' | translate }}</p></div>
                <div class="p-2 flex flex-fill claim-field-content col-7 p-0">
                  <input class="form-control form-control-sm form-input-style m-0" type="text" [value]="data.reward.game_name" disabled>
                </div>
              </div>

              <div class="d-flex justify-content-evenly claim-field mb-2">
                <div class="p-2 flex flex-fill claim-field-label col-5"><p class="m-0 pt-1 pl-2">{{ 'FRB Count' | translate }}</p></div>
                <div class="p-2 flex flex-fill claim-field-content col-7 p-0">
                  <input class="form-control form-control-sm form-input-style m-0" type="text" [value]="data.reward.frb_count" disabled>
                </div>
              </div>

            <div class="form-group col-md-12 p-0">
                <label class="mb-0 mt-1 col-12 text-left pl-0 h6" style="color: white; opacity: 40%;">
                  {{ 'Challenge Reminder' | translate }}
                </label>
                <label class="turn-over-text mb-0 mt-1 col-12 text-left pl-0">
                  <b>{{ 'To complete this promotion, you will have to:' | translate }}</b>
                </label>
                <br><br>
                <label class="turn-over-text mb-0 mt-1 col-12 text-left pl-0 pr-0" style="text-align: unset !important;">
                  {{ '1) In Challenge 1, complete the FRB round and' | translate }}&nbsp;<b>{{ 'win at least' | translate }}</b>&nbsp;<b>{{ data.reward.currency_code }} {{ data.reward.target_amount | number: '1.2-2' }}.</b> 
                </label>
                <label class="turn-over-text mb-0 mt-1 col-12 text-left pl-0">
                  {{ '2) In Challenge 2,' | translate }}&nbsp;<b>{{ data.reward.p2_target_type_name == 'Turnover' ? ('bet' | translate) :  ('win to' | translate)}}&nbsp;{{ 'at least a total of' | translate }}</b>&nbsp;<b>{{ data.reward.currency_code }} {{ data.reward.p2_target_amount | number: '1.2-2' }}</b>&nbsp;{{ 'using the given initial bonus amount' | translate}}.
                </label>
                <br><br>
                <label class="turn-over-text mb-0 mt-1 col-12 text-left pl-0 pr-0">
                  <b style="color: #EFD700 !important;">
                    {{ 'If you have a remaining balance in the selected game wallet. This balance will be transferred back to the main wallet before the promotion application.' | translate }}
                  </b>
                </label>
              </div>
            </ng-container>
          </ng-template>

          <ng-template #btgChallenge>
            <ng-container *ngIf="promoType('BTG_CHALLENGE_PHASE_1', data.reward); else transferTypePromo">
              <div class="d-flex justify-content-evenly claim-field mb-2">
                <div class="p-2 flex flex-fill claim-field-label col-5"><p class="m-0 pt-1 pl-2">{{ 'Game Provider' | translate }}</p></div>
                <div class="p-2 flex flex-fill claim-field-content col-7 p-0">
                  <input class="form-control form-control-sm form-input-style m-0" type="text" [value]="gameProviderName" disabled>
                </div>
              </div>

              <div class="d-flex justify-content-evenly claim-field mb-2">
                <div class="p-2 flex flex-fill claim-field-label col-5"><p class="m-0 pt-1 pl-2">{{ 'Bonus Amount' | translate }}</p></div>
                <div class="p-2 flex flex-fill claim-field-content col-7 p-0">
                  <input class="form-control form-control-sm form-input-style m-0" type="text" [value]="data.reward.amount" disabled>
                </div>
              </div>

            <div class="form-group col-md-12 p-0">
                <label class="mb-0 mt-1 col-12 text-left pl-0 h6" style="color: white; opacity: 40%;">
                  {{ 'Challenge Reminder' | translate }}
                </label>
                <label class="turn-over-text mb-0 mt-1 col-12 text-left pl-0">
                  <b>{{ 'To complete this promotion, you will have to:' | translate }}</b>
                </label>
                <br><br>
                <label class="turn-over-text mb-0 mt-1 col-12 text-left pl-0 pr-0" style="text-align: unset !important;">
                  {{ '1) In Challenge 1,' | translate }}&nbsp;<b>{{ 'win at least' | translate }}</b>&nbsp;<b>{{ data.reward.currency_code }} {{ data.reward.target_amount | number: '1.2-2' }}</b>
                </label>
                <label class="turn-over-text mb-0 mt-1 col-12 text-left pl-0 pr-0" style="text-align: unset !important;">
                  {{ '2) In Challenge 2,' | translate }}&nbsp;<b>{{ data.reward.p2_target_type_name == 'Turnover' ? ('bet' | translate) :  ('win to' | translate)}}&nbsp;{{ 'at least a total of' | translate }}</b>&nbsp;<b>{{ data.reward.currency_code }} {{ data.reward.p2_target_amount | number: '1.2-2' }}</b>&nbsp;{{ 'using the given initial bonus amount' | translate}}.
                </label>
                <br><br>
                <label class="turn-over-text mb-0 mt-1 col-12 text-left pl-0 pr-0">
                  <b style="color: #EFD700 !important;">
                    {{ 'If you have a remaining balance and free spin in the selected game wallet. This balance will be transferred back to the main wallet and free spin will be forfeit before the promotion application.' | translate }}
                  </b>
                </label>
              </div>
            </ng-container>
          </ng-template>

          <ng-template #transferTypePromo>
            <div class="d-flex justify-content-evenly claim-field mb-2">
              <div class="p-2 flex flex-fill claim-field-label col-5"><p class="m-0 pt-1 pl-2">{{ 'Transfer From' | translate }}</p></div>
              <div class="p-2 flex flex-fill claim-field-content col-7">
                <select formControlName="transfer_from" class="col" [ngClass]="{'form-invalid dropdown-invalid' : checkValidity && form.controls.transfer_from.errors}">
                  <option [value]="null" disabled>{{ 'Please Select' | translate }}</option>
                  <ng-container *ngFor="let item of providerList">
                    <option [value]="item.id" [disabled]="item.status === 2">{{ item.name}}</option>
                  </ng-container>
                </select>
              </div>
            </div>

            <div class="d-flex justify-content-evenly claim-field mb-2" [ngClass]="{ 'is-invalid' : form.controls['transfer_to'].errors }">
              <div class="p-2 flex flex-fill claim-field-label col-5"><p class="m-0 pt-1 pl-2">{{ 'Transfer To' | translate }}</p></div>
              <div class="p-2 flex flex-fill claim-field-content col-7">
                <select formControlName="transfer_to" class="col grey" (change)="onSelectTransferTo($event)">
                  <option [value]="null" disabled>{{ 'Please Select' | translate }}</option>
                  <ng-container *ngFor="let item of providersDropdown">
                    <option [value]="item.id" [disabled]="item.status === 2">{{ item.name}}</option>
                  </ng-container>
                </select>
              </div>
            </div>

            <div class="d-flex justify-content-evenly claim-field mb-2">
              <div class="p-2 flex flex-fill claim-field-label col-5"><p class="m-0 pt-1 pl-2">{{ 'Transfer Amount' | translate }}</p></div>
              <div class="p-2 flex flex-fill claim-field-content col-7 p-0">
                <input class="form-control form-control-sm form-input-style m-0" formControlName="amount" type="number" placeholder="{{ 'Enter Amount' | translate }}">
              </div>
            </div>

            <div class="d-flex justify-content-evenly claim-field mb-2" *ngIf="form.value.transfer_to !== null">
              <div class="p-2 flex flex-fill claim-field-label col-5"><p class="m-0 pt-1 pl-2">{{ 'Bonus Amount' | translate }}</p></div>
              <div class="p-2 flex flex-fill claim-field-content col-7 p-0">
                <input class="form-control form-control-sm form-input-style m-0" type="text" placeholder="{{ 'Enter Amount' | translate }}" [value]="onBonusAmount(+form.value.amount, data.reward)" digitOnly decimal="true" decimalSeparator="." pattern="^\d+(\.\d{1,2})?$" disabled="">
              </div>
            </div>

            <div class="d-flex justify-content-evenly claim-field mb-2" *ngIf="form.controls.transfer_to.errors">
              <p class="exchange-font m-b-0 mt-1">
                {{ 'Please select the game wallet to transfer the reward amount.' | translate }}
              </p>
            </div>

            <div class="mb-4" *ngIf="form.value.transfer_to !== null">
              <p class="exchange-font m-b-0 mt-1">
                {{ 'You are entitled to promotion(s) for this game provider' | translate }}
              </p>
              <p class="exchange-font" *ngIf="data.reward.promo_type != 4">
                {{ onDisplayTargetName(form.value.transfer_to) | translate }}: <br>
                {{ onDisplayFormula(+form.value.amount, data.reward, form.value.transfer_to) }}
              </p>
              <!-- <p class="exchange-font">
                  {{ 'Bonus' | translate }}: {{ data.reward.currency_code + ' ' + onBonusAmount(+form.value.amount, data.reward) }}
              </p> -->
            </div>

          </ng-template>

          <button type="submit" class="btn-blue-gra m-t-0 m-b-20" [ngClass]="form.valid ? '' : 'disabled'" [disabled]="form.valid === false || buttonLoading" (click)="submit()">{{ 'Submit' | translate | uppercase }}</button>
        </form>
      </div>
    </div>
  </div>
</div>